import * as React from 'react';
import { useProdutosStore } from '../store/ProdutosStore';
import PropTypes from 'prop-types';
import { PieChart } from '@mui/x-charts/PieChart';
import { useDrawingArea } from '@mui/x-charts/hooks';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';


const StyledText = styled('text', {
  shouldForwardProp: (prop) => prop !== 'variant',
})(({ theme }) => ({
  textAnchor: 'middle',
  dominantBaseline: 'central',
  fill: (theme.vars || theme).palette.text.secondary,
  variants: [
    {
      props: {
        variant: 'primary',
      },
      style: {
        fontSize: theme.typography.h5.fontSize,
      },
    },
    {
      props: ({ variant }) => variant !== 'primary',
      style: {
        fontSize: theme.typography.body2.fontSize,
      },
    },
    {
      props: {
        variant: 'primary',
      },
      style: {
        fontWeight: theme.typography.h5.fontWeight,
      },
    },
    {
      props: ({ variant }) => variant !== 'primary',
      style: {
        fontWeight: theme.typography.body2.fontWeight,
      },
    },
  ],
}));

function PieCenterLabel({ primaryText, secondaryText }) {

  const { width, height, left, top } = useDrawingArea();
  const primaryY = top + height / 2 - 10;
  const secondaryY = primaryY + 24;

  return (
    <React.Fragment>
      <StyledText variant="primary" x={left + width / 2} y={primaryY}>
        {primaryText}
      </StyledText>
      <StyledText variant="secondary" x={left + width / 2} y={secondaryY}>
        {secondaryText}
      </StyledText>
    </React.Fragment>
  );
}

PieCenterLabel.propTypes = {
  primaryText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string.isRequired,
};

const colors = [
  '#4E79A7',
  '#F28E2B',
  '#76B7B2',
  '#59A14F',
  '#EDC948',
  '#B07AA1',
  '#FF9DA7',
  '#9C755F',
  '#BAB0AC',
];

export default function GraficoPrincipal() {
  const { hanking_de_produtos, total_de_produtos_ja_vendidos, mostrar_grafico } = useProdutosStore();

  if (mostrar_grafico && hanking_de_produtos.length > 0) {
    const data = hanking_de_produtos

    const totalTop10 = data.reduce((acc, item) => acc + item.value, 0);

    const getArcLabel = (data) => {
      const percent = data.value / totalTop10;
      return `${(percent * 100).toFixed(1)}%`;
    };

    return (
      <Card
        variant="outlined"
        sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flexGrow: 1 }}
      >
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          * Dados referentes ao mês corrente.
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'spaceBetween' }}>
          <PieChart
            colors={colors}
            margin={{
              left: 80,
              right: 80,
              top: 80,
              bottom: 80,
            }}

            series={[
              {
                arcLabel: getArcLabel,
                data,
                innerRadius: 75,
                outerRadius: 130,
                paddingAngle: 0,
                highlightScope: { fade: 'global', highlight: 'item' },
              },
            ]}
            height={260}
            width={260}
            hideLegend

          >
            <PieCenterLabel primaryText={total_de_produtos_ja_vendidos} secondaryText="Produtos vendidos" />
          </PieChart>
        </Box>

        {data.map((produtos, index) => (
          <Stack
            key={index}
            direction="row"
            sx={{ alignItems: 'center', gap: 2, pb: 2 }}
          >
            {produtos.flag}
            <Stack sx={{ gap: 1, flexGrow: 1 }}>
              <Stack
                direction="row"
                sx={{
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: '500' }}>
                  {produtos.label}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {produtos.value}
                </Typography>
              </Stack>
              <LinearProgress
                variant="determinate"
                aria-label="Number of users by country"
                value={(produtos.value / totalTop10) * 100} // normaliza para %
                sx={{
                  [`& .${linearProgressClasses.bar}`]: {
                    backgroundColor: colors[index],
                  },
                }}
              />
            </Stack>
          </Stack>
        ))}
      </Card>
    );
  }

  return (
    <Card
      variant="outlined"
      sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flexGrow: 1 }}
    >
      <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
        * Para ver o gráfico dos 10 produtos mais vendidos no mês faça uma venda.
      </Typography>
    </Card>
  );

}
